import { services } from '../services';

const buddyStore = {
  state: {
    buddies: undefined,
    pendingBuddies: undefined,
    buddyRequests: undefined,
    lastFetchBuddies: undefined,
    lastFetchPending: undefined,
    lastFetchRequests: undefined,
    shareCode: undefined,
    lastupdateBuddiesMemberGuid: '',
    lastupdateBuddyRequestsMemberGuid: '',
    lastupdatePendingBuddiesMemberGuid: '',
  },

  mutations: {
    updateBuddies(state, payload) {
      state.buddies = payload.buddies;
      state.lastupdateBuddiesMemberGuid = payload.memberGuid;
      state.lastFetchBuddies = new Date();
    },
    updatePendingBuddies(state, payload) {
      state.pendingBuddies = payload.pendingBuddies;
      state.lastupdatePendingBuddiesMemberGuid = payload.memberGuid;
      state.lastFetchPending = new Date();
    },
    updateBuddyRequests(state, payload) {
      state.buddyRequests = payload.buddyRequests;
      state.lastupdateBuddyRequestsMemberGuid = payload.memberGuid;
      state.lastFetchRequests = new Date();
    },
    updateShareCode(state, code) {
      state.shareCode = code;
    },
    emptyBuddyCache(state) {
      state.buddies = undefined;
      state.pendingBuddies = undefined;
      state.buddyRequests = undefined;
      state.lastFetchBuddies = undefined;
      state.lastFetchPending = undefined;
      state.lastFetchRequests = undefined;
      state.shareCode = undefined;
    },
  },

  actions: {
    async updateBuddies(context) {
      const buddies = await services.buddy.buddies();
      const payload = {};
      payload.buddies = buddies;
      payload.memberGuid = context.rootState.user.userGuid;
      context.commit('updateBuddies', payload);
    },
    async updatePendingBuddies(context) {
      const pending = await services.buddy.pendingBuddies();
      const payload = {};
      payload.pendingBuddies = pending;
      payload.memberGuid = context.rootState.user.userGuid;
      context.commit('updatePendingBuddies', payload);
    },
    async updateBuddyRequests(context) {
      const requests = await services.buddy.buddyRequests();
      const payload = {};
      payload.buddyRequests = requests;
      payload.memberGuid = context.rootState.user.userGuid;
      context.commit('updateBuddyRequests', payload);
    },
    async populateShareCode(context) {
      const shareCode = await services.buddy.buddyShareToken();
      context.commit('updateShareCode', shareCode);
    },
    async emptyBuddyStore({ commit }) {
      commit('emptyBuddyCache');
    },
  },
};

export { buddyStore };
